module.exports = __webpack_public_path__ + "static/media/JAGJIT-SINGH.e1b6a7f3.png";